export class ShareAdapter {
    share(url, title = '', desc = '') {
        this.doShare({
            url: url,
            title: title,
            desc: desc
        });
    }
    doShare(data) {
        logger.error('no sharing code');
    }
    init(data, scriptManager) {
        this._data = data;
        this._scriptManager = scriptManager;
        this.doInit();
    }
    doInit() {
    }
}
